import { Popover, Typography } from '@mui/material';
import React, { Fragment } from 'react';

export const StatusValueColorIcon = ({ color, title = '', size = '20px' }: any) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Fragment>
      <div
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        style={{
          width: size,
          height: size,
          //@ts-ignore
          '-webkit-border-radius': '25px',
          '-moz-border-radius': '25px',
          'border-radius': '25px',
          background: color,
        }}
      ></div>
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: 'none',
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography sx={{ p: 2 }}>{title}</Typography>
      </Popover>
    </Fragment>
  );
};
